/**
 * File types the document-import picker offers.
 *
 * `.txt` rides on the document-import route but is handled by the text-intake
 * pipeline, so it comes and goes with `FEATURE_TEXT_INTAKE` (#1149). PDFs and
 * images are OCR and never gated. Kept in one place because two pickers build
 * this string — `ImportPreCreationModal` and `ViewRequests.handleImportFile` —
 * and they must offer the same set.
 */
const DOCUMENT_IMPORT_ACCEPT_BASE = '.pdf,image/*';
const TEXT_IMPORT_ACCEPT = '.txt,text/plain';

export const buildDocumentImportAccept = (textIntakeEnabled: boolean): string =>
  textIntakeEnabled
    ? `${DOCUMENT_IMPORT_ACCEPT_BASE},${TEXT_IMPORT_ACCEPT}`
    : DOCUMENT_IMPORT_ACCEPT_BASE;
